module.exports = __webpack_public_path__ + "media/packs/faq/images/header-img3-ac6907964b988f5c6ab2d5954e50448e.svg";